export const ROUTES = {
  HOME: '/',
  TERMS_PRIVACY: '/terms-and-privacy',
  LEGAL: '/legal',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  PRACTICE: '/practice',
  QUANT: '/quantitative_reasoning',
  VERBAL: '/verbal_reasoning',
  DATA: '/data_insights',
  PRACTICE_SESSION: '/practice/:sessionId',
  COURSES: '/courses',
  COURSE_DETAIL: '/courses/:courseId',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  NOT_FOUND: '*',
} as const;

export const createRoute = {
  practiceSession: (sessionId: string) => `/practice/${sessionId}`,
  courseDetail: (courseId: string) => `/courses/${courseId}`,
} as const;
